import { render, staticRenderFns } from "./myContinuationPreservation.vue?vue&type=template&id=4c977841&"
import script from "./myContinuationPreservation.vue?vue&type=script&lang=js&"
export * from "./myContinuationPreservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports